import * as React from 'react';
import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import Fab from '@mui/material/Fab';

import EditIcon from '@mui/icons-material/Edit';

import { AppBar, Paper, Alert, Snackbar } from '@mui/material';
import { base_url } from '../Sevices/API';
import { UserContext } from '../Components/Usercontext';
import ResponsiveAppBar from '../Components/AppBar';


export default function Profile() {
   const {userInfo,setUserInfo,image,setImage} =React.useContext(UserContext);
  const [file,setFile]=useState("");
  const [photo, setPhoto]=React.useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [loading, setLoading] = useState(false);

  const hiddenFileInput = React.useRef(null);


  React.useEffect(()=>{
    var token=localStorage.getItem('token')||"";

    fetch(`${base_url}/profile`,{
     method:"post",
     headers:{
       "Content-type":"application/json"
     },
     body:JSON.stringify({'token':token}),
  

    })
    .then((res)=>{
      res.json().then((info)=>{
        
        setUserInfo(info);
        fetch(`${base_url}/photo/?Author=${info.id}`)
        .then((res)=>{
          return res.json();
        })
        .then((json)=>{
       
       
     
          setPhoto(json.img);
          
        })
        .catch((err)=>{
         console.log("Error");
        
        })
       
      
      
      })
      .catch((err)=>{
       setUserInfo({Email:"",Name:"",id:""});
       console.log("Error");
      })
    })

  },[])

  const handleClick=()=>{
    hiddenFileInput.current.click();
  }

  const handleChange=(e)=>{
    setPhoto(null)
    setImage(URL.createObjectURL(e.target.files[0]));
     setFile(e.target.files)
  }

  const postImage=()=>{
    setLoading(true);
    let token=localStorage.getItem('token')||"";
    const data=new FormData();

    data.set('file',file[0]);

    data.set('token',token);

    // console.log(token);
    fetch(`${base_url}/photo`,{
      method:"POST",
       body:data,


    })
    .then((res)=>{
      setAlertMessage("Successfully Updated");
      setAlertSeverity('success');
      setAlertOpen(true);
      setLoading(false);

    })
    .catch((err)=>{
      setAlertMessage("Update Failed");
      setAlertSeverity('error');
      setAlertOpen(true);
      setLoading(false);
      console.log('error');
    })
  }

  return <>
    <ResponsiveAppBar/>

    <div className='profileContainer' direction="row" spacing={2}>
        <Paper className='profilePaper' elevation={20}>
          <div>
      {photo ?  <Avatar alt="Remy Sharp" src={photo}   sx={{ width: 300, height: 300 }} />: <Avatar alt="Remy Sharp" src={image}   sx={{ width: 300, height: 300 }} />}
      <Fab className='editIcon'  onClick={handleClick} color="secondary" aria-label="edit">
        <EditIcon />

      </Fab>
      <input type='file'  ref={hiddenFileInput}
        onChange={handleChange}
       style={{display:"none"}} ></input>
        </div>
        <Button variant="contained" onClick={postImage} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
        </Paper>

    </div>
    <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)}>
      <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
    </>
}